import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;

  @media ${({ theme }) => theme.devices.mobileL} {
    flex-direction: column;
    margin-top: 10px;
  }
`;

export const BannerItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: space-between;
  background-color: ${({ theme }) => theme.colors.white.normal};
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: ${({ theme }) => theme.borderRadius};
  box-sizing: border-box;

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const BannerTitle = styled.h2`
  margin: 0px;
  max-width: 600px;
  color: ${({ theme }) => theme.colors.green.normal};
  font-size: ${({ theme }) => theme.fontSize.md2};
`;

export const BannerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  width: 100%;
  margin-left: 20px;
  padding: 20px;
  font-size: ${({ theme }) => theme.fontSize.mm};
  color: ${({ theme }) => theme.colors.gray.dark};

  @media ${({ theme }) => theme.devices.tablet} {
    margin: 0px;
    padding: 0px 5px;
  }
`;

export const Icon = styled.div`
  > svg {
    margin-right: 15px;
    color: ${({ theme }) => theme.colors.green.light};
  }
`;

export const Location = styled.span`
  padding: 5px 0;
  color: ${({ theme }) => theme.colors.gray.dark};
`;

export const Date = styled.span`
  padding: 5px 0;
  color: ${({ theme }) => theme.colors.gray.dark};
  display: flex;
`;

export const Error = styled.span`
  padding: 5px 0;
  color: ${({ theme }) => theme.colors.red.normal};
`;

export const Link = styled.a`
  box-sizing: border-box;
  width: 225px;
  background-color: ${({ theme }) => theme.colors.green.normal};
  color: ${({ theme }) => theme.colors.white.normal};
  font-weight: bold;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 5px;
  text-decoration: none;
  transition: transform ${({ theme }) => theme.animation.duration};
  will-change: transform;
  transform: scale(1);
  font-size: ${({ theme }) => theme.fontSize.sm};
  align-self: center;
  text-align: center;

  &:hover {
    transform: scale(1.05);
  }

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const Button = styled.button`
  box-sizing: border-box;
  width: 225px;
  background-color: ${({ theme }) => theme.colors.green.normal};
  color: ${({ theme }) => theme.colors.white.normal};
  font-weight: bold;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 5px;
  text-decoration: none;
  transition: transform ${({ theme }) => theme.animation.duration};
  will-change: transform;
  transform: scale(1);
  font-size: ${({ theme }) => theme.fontSize.sm};
  align-self: center;
  text-align: center;
  border: none;

  &:hover {
    transform: scale(1.05);
  }

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  box-sizing: border-box;
  position: absolute;
  background: none;
  justify-content: end;
  padding: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.red.normal};
  border-radius: 5px 0 0 0px;
  font-weight: bold;
  text-decoration: none;
  transition: transform ${({ theme }) => theme.animation.duration};
  will-change: transform;
  transform: scale(1);
  font-size: ${({ theme }) => theme.fontSize.md};
  border: none;

  &:hover {
    transform: scale(1.05);
  }

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 400px;
  padding: 20px;
  img {
    display: flex;
    object-fit: cover;
    min-heigth: 200px;
    min-width: 200px;
    justify-content: center;
    align-items: center;
  }
  button {
    margin-top: 15px;
  }
`;

export const Data = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;
export const DataImage = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 45px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  gap: 10px;

  @media ${({ theme }) => theme.devices.mobileL} {
    margin-top: 10px;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;

  align-items: center;
  justify-content: center;

  gap: 16px;

  p {
    font-weight: bold;
    font-size: 1.2rem;

    text-align: center;
  }
`;

export const DeleteContainerButtons = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;

  gap: 16px;

  buttons {
    width: fit-content;
  }
`;
export const FormRow = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;

  .filepond--wrapper {
    width: 100%;
  }
  .filepond--panel-root {
    background: #fff;

    border: 1px dashed #a0aec0;
  }
  .filepond--drop-label label {
    width: 100%;
    cursor: pointer;
  }
  .content-filepond {
    display: flex;
    width: 100%;
    text-align: center;
    align-items: center;
  }
  .content-filepond p {
    margin: 0 auto;
  }
  .content-filepond svg {
    margin-left: 32px;
    font-size: var(--chakra-fontSizes-4xl);
    color: var(--chakra-colors-green-700);
  }
`;
